var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rotaion',{attrs:{"height":_vm.height,"route":this.$route.path,"arrow":"never","position":"none"}}),_c('div',{staticClass:"center-content"},[_c('Invite'),_c('bottom')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }